import { ICoordinateSystem } from '@app/api/interfaces/coordinate-system.interface';
import { convertStringInToSumOfAllCharacters } from '@app/shared/utils/string';

export const coordinateSystemsMockData: ICoordinateSystem[] = [
  {
    id: '31467',
    name: 'DHDN / 3-degree Gauss-Kruger zone 3',
    axis1Label: 'X',
    axis1Unit: 'm',
    axis2Label: 'Y',
    axis2Unit: 'm',
  },
  {
    id: '2227',
    name: 'NAD83 / California zone 3 (ftUS)',
    axis1Label: 'Easting',
    axis1Unit: 'ftUS',
    axis2Label: 'Northing',
    axis2Unit: 'ftUS',
  },
  {
    id: '31287',
    name: 'MGI / Austria Lambert',
    axis1Label: 'Y',
    axis1Unit: 'm',
    axis2Label: 'X',
    axis2Unit: 'm',
  },
  {
    id: '4258',
    name: 'ETRS89 (geographic)',
    axis1Label: 'Lat',
    axis1Unit: '°',
    axis2Label: 'Lon',
    axis2Unit: '°',
  },
  {
    id: 'local-grid',
    name: 'Site local grid',
    axis1Label: 'X',
    axis1Unit: '',
    axis2Label: 'Y',
    axis2Unit: '',
  },
  {
    id: '27700',
    name: 'OSGB 1936 / British National Grid',
    axis1Label: 'E',
    axis1Unit: 'm',
    axis2Label: 'N',
    axis2Unit: 'm',
  },
];

export function coordinateSystemForProject(projectId: string): ICoordinateSystem {
  return coordinateSystemsMockData[convertStringInToSumOfAllCharacters(projectId) % coordinateSystemsMockData.length];
}
